/**
 * Config values
 */
const Config = {
  BACKEND_API_URL: window.location.href.indexOf('localhost:') !== -1 ? '//localhost:3001/' : '//api.wipehero.com/',
  //BACKEND_API_URL: '//api.wipehero.com/',
  
  STRIPE_PUBLIC_KEY: window.location.href.indexOf('localhost:') !== -1 ?
      'pk_test_xvbtPJuP8Wy3tyPMpUfNnaqV' :
      'pk_live_vVUEFH0anLBNLkCbUaR2qVrE',

  CLIENT_NAME: 'McCarrolls',
  CLIENT_PREFIX: 'MC',

  GOOGLE_API_KEY: 'AIzaSyDatYWCPqsw3XwgAT8yihp6RVph8fgHhFo'
};

export default Config;



// WEBPACK FOOTER //
// ./src/conf.js